import { Async } from "react-select"
import React from "react"

import SelectTagItem from "./SelectTagItem"

/**
 * SelectTags adds some sensible defaults to most of the props that are used
 * across the dashboard to make using react-select easier.
 *
 * They are done in such a way that they can be overridden however.
 */
const SelectTags = ({
    labelKey,
    valueKey,
    autoload,
    scrollMenuIntoView,
    valueComponent,
    className,
    SelectComponent,
    multi,
    ...rest
}) => {
    const Component = SelectComponent || Async

    return (
        <Component
            multi={multi !== undefined ? multi : true}
            valueComponent={valueComponent || SelectTagItem}
            className={className || "tags select-tags"}
            labelKey={labelKey || "name"}
            valueKey={valueKey || "id"}
            autoload={autoload || false}
            scrollMenuIntoView={scrollMenuIntoView || false}
            {...rest}
        />
    )
}

export default SelectTags
